import { catchError } from 'rxjs/operators';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
  } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NecHealthInterface } from './../health/health.interface';
import { Observable, of, throwError } from 'rxjs';


// don't forget the imports

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ç±äºHttpClientå¾ªç¯ä¾èµï¼éç¨æ³¨å¥å¨æ³¨å¥
    const healthInterface = this.injector.get(NecHealthInterface);
    return next.handle(request)
      .pipe(catchError((err: HttpErrorResponse) => {
        if (err.status >= 200 && err.status < 300) {
          return of(new HttpResponse());
        }
        if (err.status === 503 || err.status === 502 || err.status === -1 || err.status === 0) {
          setTimeout(() => {
            healthInterface.getServerHealthStatus()
              .subscribe(status => {
                if (!status) {
                  location.href = location.origin + '/503.html';
                }
              }, () => {
                location.href = location.origin + '/503.html';
              });
          }, 200);
        }
        return throwError(err);
      }));
  }
}
